
import { Component, effect, inject, OnDestroy, OnInit, Signal, signal } from '@angular/core';
import { finalize, Subscription } from 'rxjs';
import { StorageProducts } from '../../../../../../../core/service/cart-apis/interfaces/cart.interface';
import { ShopCartService } from '../../../../../shop-cart/service/shop-cart.service';
import { ProcessPaymentService } from './service/process-payment.service';
import { ListCardsUserComponent } from '../list-cards-user/list-cards-user.component';
import { environment } from '../../../../../../../../environments/environment';
import { MercadoPagoErrorsService } from '../../../../../../../core/service/mercado-pago/mercado-pago-errors.service';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { NotificationsService } from '../../../../../../components/notifications/service/notifications.service';
import { OrderProcessingService } from '../../../../../../../core/service/socket/socket-processing-order.service';
import { AuthService } from '../../../../../../../core/service/auth.service';
import { NotificationEstablishmentService } from '../../../../../../components/notification-establishment/service/notification-establishment.service';
import { SocketService } from '../../../../../../../core/service/socket/socket.service';
import { Card } from '../list-cards-user/interfaces/list-cards-user.interface';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppState } from '../../../../../../../store/app.state';
import { getBalance } from '../../../../../../../features/perfil-user/store/balance.selector';
import { CalculateTotalService } from '../../../../../../../core/service/calculateTotal/calculate-total.service';
import { BalanceService } from '../../../../../balance/service/balance.service';
import { ResumenPedidoService } from '../../../../../../../features/detail-orden-checkout/components/resumen-pedido/service/resumen-pedido.service';
import { LoaderSubitoService } from '../../../../../loader-subito/service/loader-subito.service';
import { PaymentCheckoutResponse, PaymentData } from './interfaces/payload.interface';
import { DevolucionDineroModalService } from '../../../../../../../features/devolucion-dinero/service/devolucion-dinero-modal.service';
import { CartService } from '../../../../../../../core/service/cart-apis/cart.service';
import { Router } from '@angular/router';
import { CashPaymentComponent } from "../../../../cash-payment/cash-payment.component";
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PerfilUserService } from '../../../../../../../features/perfil-user/service/perfil-user.service';
import { setBalance } from '../../../../../../../features/perfil-user/store/balance.actions';



@Component({
  selector: 'mercado-pago-process-payment',
  standalone: true,
  imports: [
    CommonModule,
    ListCardsUserComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './process-payment.component.html',
  styleUrl: './process-payment.component.css'
})
export class ProcessPaymentComponent implements OnInit, OnDestroy {
  products: StorageProducts[] = [];
  private stripe: Stripe | null = null;
  private subscription: Subscription = new Subscription;
  selectedCard: any = null;
  modalMessage: string = '';
  private readonly stripePublicKey = environment.stripePagoPublicKey;
  errorMessage: string = '';
  private paymentSubscription: Subscription | null = null;
  isProcessing = signal(false);
  balance: Signal<string | undefined>;
  showCards = signal(false);
  isPaymentWithBalance = signal(false);
  hideRadioCard = signal(false);
  fb = inject(FormBuilder);
  paymentForm = this.fb.group({
    paymentMethod: ['cash'],
  });
  constructor(private shopCartService: ShopCartService,
    private processPaymentService: ProcessPaymentService,
    private mpErrorsService: MercadoPagoErrorsService,
    private notificationsService: NotificationsService,
    private orderProcesing: OrderProcessingService,
    private authService: AuthService,
    private notificationEstablishmentService: NotificationEstablishmentService,
    private socketService: SocketService,
    private store: Store<AppState>,
    private calculateTotalService: CalculateTotalService,
    private balanceService: BalanceService,
    private resumenPedidoService: ResumenPedidoService,
    private loaderService: LoaderSubitoService,
    private devolucionDineroModalService: DevolucionDineroModalService,
    private cartService: CartService,
    private router: Router,
    private perfilUserService:  PerfilUserService
  ) {
    this.balance = toSignal(this.store.select(getBalance));
    // console.log('balance', this.balance());
    // console.log('DevolucionDineroModalService in constructor:', this.devolucionDineroModalService);
    this.isPayWithBalance()


    // La suscripción al cambio de método de pago debe registrarse una sola vez

    // Efecto para recalcular visibilidad de tarjeta al cambiar totales y balance
    effect(() => {
      // Leer señales reactivas para que el efecto se dispare
      const cart = this.calculateTotalService.cartTotal();
      const shipping = this.calculateTotalService.shippingCost();
      const tip = this.calculateTotalService.deliveryTip();
      const base = this.calculateTotalService.tarifaBase();
      const servicio = this.calculateTotalService.tarifaServicio();
      const bal = this.balance();
      // Recalcular decisión de pago con balance y visibilidad de tarjeta
      this.isPayWithBalance();
    });
  }

  async ngOnInit(): Promise<void> {
    await this.initStripe();
    this.subscription.add(
      this.shopCartService.getProducts().subscribe((products: StorageProducts[]) => {
        this.products = products;
        this.processPaymentService.products = this.products;
        // console.log('products', this.products);
      })
    );

    // Suscribirse una sola vez a los cambios del método de pago
    const paymentMethodSub = this.paymentForm.get('paymentMethod')?.valueChanges.subscribe(value => {
      if (value) {
        this.onPaymentMethodChange(value);
      }
    });
    if (paymentMethodSub) {
      this.subscription.add(paymentMethodSub);
    }

    // Verificar el balance inicialmente
    this.isPayWithBalance();

    // Observar cambios en la propina usando el servicio ResumenPedidoService
    this.subscription.add(
      this.resumenPedidoService.getTip$().subscribe(() => {
        // Cuando cambia la propina, verificar nuevamente si el balance es suficiente
        this.isPayWithBalance();
      })
    );

    // Suscribirse a cambios en el estado de pago con balance
    this.subscription.add(
      this.balanceService.isPaymentWithBalanceChanged.subscribe(isPaymentWithBalance => {
        // console.log('Estado de pago con balance actualizado:', isPaymentWithBalance);
        this.isPaymentWithBalance.set(isPaymentWithBalance);
      })
    );
  }
  ngOnDestroy() {
    this.socketService.removeListener('orderDelivery');
    this.subscription.unsubscribe();
    if (this.paymentSubscription) {
      this.paymentSubscription.unsubscribe();
    }
  }
  private async initStripe(): Promise<void> {
    try {
      this.stripe = await loadStripe(this.stripePublicKey);
      if (!this.stripe) {
        throw new Error('Failed to load Stripe');
      }
    } catch (error) {
      console.error('Error initializing Stripe:', error);
      this.errorMessage = 'Error al inicializar el servicio de pago';
    }
  }

  onCardSelected(event: { card: Card, cvv: string | null }) {
    this.selectedCard = event.card;
  }

  async processPayment() {
    // console.log('hola');

    this.isProcessing.set(true);
    this.errorMessage = '';

    try {
      // Verificar si hay suficiente saldo para pagar sin tarjeta
      if (this.paymentForm.value.paymentMethod === 'cash') {
        this.paymentWithCash();
        return;
      }

      if (this.isPayWithBalance()) {
        this.isPaymentWithBalance.set(true);
        await this.processPaymentWithBalance();
        return;
      }

      // Si hay una tarjeta seleccionada, procesar el pago con tarjeta
      if (this.selectedCard) {
        await this.processPaymentWithCard();
      } else {
        this.errorMessage = 'Por favor selecciona una tarjeta de pago';
        this.isProcessing.set(false);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      this.errorMessage = 'Error al procesar el pago. Inténtalo de nuevo.';
      this.isProcessing.set(false);
    }
  }

  private async processPaymentWithBalance() {
    this.loaderService.showLoader();
    try {
      this.paymentSubscription = this.processPaymentService.processPayment(undefined, 6).subscribe({
        next: (response) => {
          // console.log('Payment success with balance:', response);
          this.notificationsService.addNotification({
            message: 'Pago con saldo procesado exitosamente',
            type: 'success'
          });
          this.loaderService.hideLoader();
          this.handleSuccess(response.data);
          this.resetPaymentState();
          this.cartService.clearCart().subscribe({
            next: () => {
              // console.log('Cart updated after payment success');
            },
            error: (cartError) => {
              console.error('Error updating cart after payment success:', cartError);
            }
          });
        },
        error: (error) => {
          this.loaderService.hideLoader();
          this.cartService.getCartFromApi().subscribe({
            next: () => {
              // console.log('Cart updated after payment error');
            },
            error: (cartError) => {
              console.error('Error updating cart after payment error:', cartError);
            }
          });
          console.error('Payment error details:', error);

        },

      });
    } catch (error: any) {
      console.error('Error processing payment with balance:', error);
      this.mpErrorsService.handleError('', error.message);
      this.resetPaymentState();
    }
  }

  private async processPaymentWithCard() {
    try {
      if (this.selectedCard && this.selectedCard.stripe_payment_method_id) {
        await this.sendPayment(this.selectedCard.stripe_payment_method_id);
      } else {
        this.errorMessage = 'Tarjeta no válida para procesar el pago';
        this.isProcessing.set(false);
      }
    } catch (error) {
      console.error('Error processing payment with card:', error);
      this.errorMessage = 'Error al procesar el pago con tarjeta';
      this.isProcessing.set(false);
    }
  }

  private async sendPayment(paymentMethodId: string) {
    this.loaderService.showLoader();
    try {
      this.paymentSubscription = this.processPaymentService.processPayment(paymentMethodId, 5).subscribe({
        next: (response: PaymentCheckoutResponse) => {

          // console.log('Payment success:', response);
          this.notificationsService.addNotification({
            message: 'Pago procesado exitosamente',
            type: 'success'
          });
          this.loaderService.hideLoader();
          this.handleSuccess(response.data);
          this.resetPaymentState();
          // Limpiar el carrito ya que el pago fue exitoso pero la orden fue rechazada
          this.cartService.clearCart().subscribe({
            next: () => {
              // console.log('Cart cleared after order rejection');
            },
            error: (error) => {
              console.error('Error clearing cart after order rejection:', error);
            }
          });
          this.router.navigate(['/auth/order/' + response.data.order_id]);

        },
        error: (error) => {
          this.loaderService.hideLoader();
          // Limpiar el carrito ya que el pago fue exitoso pero la orden fue rechazada
          this.cartService.clearCart().subscribe({
            next: () => {
              // console.log('Cart cleared after order rejection');
            },
            error: (error) => {
              console.error('Error clearing cart after order rejection:', error);
            }
          });
          this.router.navigate(['/auth/orders']);
          this.cartService.getCartFromApi().subscribe({
            next: () => {
              // console.log('Cart updated after card payment error');
            },
            error: (cartError) => {
              console.error('Error updating cart after card payment error:', cartError);
            }
          });
          console.error('Payment error details:', error);
          // this.mpErrorsService.handleHttpError(error);
          // this.resetPaymentState();
        },

      });
    } catch (error: any) {
      console.error('Error sending payment:', error);
      this.mpErrorsService.handleError('', error.message);
      // this.resetPaymentState();
    }
  }
  private resetPaymentState(): void {
    this.isProcessing.set(false);
    this.errorMessage = '';
    this.modalMessage = '';

    // Limpiar suscripciones
    if (this.paymentSubscription) {
      this.paymentSubscription.unsubscribe();
      this.paymentSubscription = null;
    }
  }
  private async handleSuccess(data: PaymentData): Promise<void> {

    if (!data?.order_id || !data?.restaurant_id) {
      throw new Error('Datos de orden incompletos');
    }

    try {
      // Mostrar el modal de notificación mientras se espera la respuesta del establecimiento
      // this.notificationEstablishmentService.toggleModal(true);

      const userId = this.authService.getUser()?.ua_id.toString()

      if (!userId) {
        // this.notificationEstablishmentService.toggleModal(false);
        throw new Error('No se encontró información del usuario');
      }

      const result = await this.orderProcesing.processOrder(
        data.order_id,
        data.restaurant_id,
        userId
      );
      // console.log('result que es', result.success);

      if (result.success) {
        // Si el pedido fue aceptado, cerrar el modal
        // this.notificationEstablishmentService.toggleModal(false);

        // this.notificationsService.addNotification({
        //   message: result.message,
        //   type: 'success',
        //   duration: 5000
        // });
      } else {
        // console.log('Order rejected, closing establishment modal and opening refund modal');
        // console.log('DevolucionDineroModalService instance:', this.devolucionDineroModalService);
        // console.log('Initial modal state:', this.devolucionDineroModalService.isOpen);

        // Si el pedido fue rechazado, cerrar el modal de notificación del establecimiento
        // this.notificationEstablishmentService.toggleModal(false);

        // Limpiar el carrito ya que el pago fue exitoso pero la orden fue rechazada
        this.cartService.clearCart().subscribe({
          next: () => {
            // console.log('Cart cleared after order rejection');
          },
          error: (error) => {
            console.error('Error clearing cart after order rejection:', error);
          }
        });

        const orderData = {
          orderId: data.order_id,
          restaurantId: data.restaurant_id,
          userId: userId,
          message: result.message,
          amount: this.calculateTotalService.calculateWithoutBalance()
        };

        // console.log('Order data to set:', orderData);

        // Configurar los datos del pedido rechazado primero
        this.devolucionDineroModalService.setOrderData(orderData);
        // console.log('Order data set, current orderData$:', this.devolucionDineroModalService.orderData$);

        // Pequeño delay para asegurar que el modal anterior se cierre completamente
        setTimeout(() => {
          // console.log('About to open refund modal');
          // console.log('Service before toggle:', this.devolucionDineroModalService.isOpen);

          // Abrir el modal de devolución de dinero
          // this.devolucionDineroModalService.toggleModal(true);

          // console.log('Service after toggle:', this.devolucionDineroModalService.isOpen);
          // console.log('isOpen$ observable value:', this.devolucionDineroModalService.isOpen$);
        }, 100);

        this.notificationsService.addNotification({
          message: result.message,
          type: 'error',
          duration: 5000
        });
      }
    } catch (error) {
      // Asegurarse de cerrar el modal en caso de error
      this.notificationEstablishmentService.toggleModal(false);
      console.error('Error en el proceso:', error);
      throw error;
    }
  }

  isPayWithBalance() {
    const balanceRaw = this.balance();
    const balanceAmount = balanceRaw ? Number(balanceRaw) : 0;
    const totalCalc = this.calculateTotalService.calculateWithoutBalance();
    const totalAmount = Number.isFinite(totalCalc) ? totalCalc : 0;
    // console.log('Verificando balance:', balanceAmount, 'vs total:', totalAmount);

    // Ajuste de epsilon para evitar problemas de redondeo (p.ej., 10 >= 10.000001)
    const hasEnoughBalance = (balanceAmount + 1e-6) >= totalAmount;

    // Actualizar el estado local y en el servicio
    this.isPaymentWithBalance.set(hasEnoughBalance);
    this.balanceService.isPaymentWithBalance.set(hasEnoughBalance);

    // Mostrar opción de tarjeta solo cuando el balance NO alcanza
    this.hideRadioCard.set(!hasEnoughBalance);

    // Si ahora el balance alcanza y el usuario tenía 'card', forzar 'cash'
    if (hasEnoughBalance && this.paymentForm.value.paymentMethod === 'card') {
      this.paymentForm.get('paymentMethod')?.setValue('cash');
      this.onPaymentMethodChange('cash');
    }

    return hasEnoughBalance;
  }
  disabledButton(): boolean {
    const method = this.paymentForm.value.paymentMethod;
    const hasEnoughBalance = Number(this.balance()) >= this.calculateTotalService.calculateWithoutBalance();
    // Permitir efectivo siempre; para tarjeta, requiere tarjeta o saldo suficiente
    if (method === 'cash') {
      return false;
    }
    return !(hasEnoughBalance || this.selectedCard);
  }


  onPaymentMethodChange(method: string) {
    if (method === 'cash') {
      // Al cambiar a efectivo, limpiar tarjeta seleccionada
      this.selectedCard = null;
      this.errorMessage = '';
    } else if (method === 'card') {
      // Al cambiar a tarjeta, mantener estado; no hacer nada especial
    }
  }

  paymentWithCash() {
    this.loaderService.showLoader();
    this.paymentSubscription = this.processPaymentService.processPayment(undefined, 1).pipe(
      finalize(() => {
        this.loaderService.hideLoader();
      })
    ).subscribe({
      next: (response) => {
        // console.log('Payment processed successfully:', response);
        // Manejar la respuesta exitosa, como mostrar una notificación
        this.notificationsService.addNotification({
          message: 'Pago con créditos realizado con éxito',
          type: 'success',
          duration: 5000
        });
        this.loaderService.hideLoader();
        this.handleSuccess(response.data);
        this.resetPaymentState();
         this.perfilUserService.getProfile().subscribe({
          next: (profile) => {
            this.store.dispatch(setBalance({ balance: profile.data.balance }))
            // console.log(profile);
          },
          error: (profileErr) => {
            console.error('Error al obtener perfil:', profileErr);
          }
        });

        // Limpiar el carrito ya que el pago fue exitoso pero la orden fue rechazada

        this.router.navigate(['/auth/order/' + response.data.order_id]);
      },
      error: (error) => {
        this.loaderService.hideLoader();
        this.resetPaymentState();
        this.router.navigate(['/auth/orders']);
        console.error('Error processing payment with cash:', error);

      }
    });
  }
}
